import styled from "styled-components"

import { minWidth } from "utils"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;
  border-bottom: 3px solid #eee;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}
`

export const OrderedList = styled.ol`
  margin: 0;
  padding: 0;
  list-style-type: none;
  counter-reset: customlistcounter;
`

export const OrderedListItem = styled.li`
  position: relative;
  margin-top: 2rem;
  padding: 0 7rem 2rem 7rem;
  border-bottom: 1px solid #eee;
  font-size: 1.8rem;
  line-height: 1.5;
  counter-increment: customlistcounter;

  &:before {
    position: absolute;
    top: -0.2rem;
    left: 2rem;
    width: 2.5rem;
    height: 2.5rem;
    border: 2px solid #b5471f;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 1.66rem;
    background-color: white;
    color: #b5471f;
    content: counter(customlistcounter) " ";
  }

  &:last-of-type {
    border-bottom: none;
  }

  ${minWidth.hamburgerLarge`
    font-size: 1.8rem;
    line-height: 1.5;
  `}
`
